import { useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, ExternalLink, BarChart3 } from "lucide-react";

export const VideoLightbox = ({ video, onClose }) => {
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  return (
    <AnimatePresence>
      {video && (
        <motion.div
          data-testid="video-lightbox"
          className="fixed inset-0 z-[70] flex items-center justify-center bg-navy-3/90 p-4 backdrop-blur-md"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onClose}
          role="dialog"
          aria-modal="true"
          aria-label={`Video di ${video.client}`}
        >
          <motion.div
            className="relative w-full max-w-sm"
            initial={{ scale: 0.92, y: 24 }}
            animate={{ scale: 1, y: 0 }}
            exit={{ scale: 0.95, opacity: 0 }}
            transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              type="button"
              data-testid="lightbox-close"
              onClick={onClose}
              aria-label="Chiudi video"
              className="absolute -top-12 right-0 flex h-10 w-10 items-center justify-center rounded-full border border-white/20 text-white transition-colors hover:bg-white hover:text-navy"
            >
              <X className="h-5 w-5" />
            </button>
            <div className="aspect-[9/16] max-h-[68vh] w-full overflow-hidden rounded-2xl bg-navy shadow-2xl">
              <video
                key={video.src}
                className="h-full w-full object-cover"
                src={video.src}
                poster={video.poster}
                controls
                autoPlay
                loop
                playsInline
                aria-label={`Video di ${video.client}`}
              />
            </div>
            <div className="mt-4 flex items-center justify-between gap-4">
              <div>
                <p className="font-display text-sm font-extrabold tracking-tight text-white">{video.client}</p>
                <p className="mt-1 flex items-center gap-1.5 font-mono text-[10px] tracking-[0.2em] text-brand-cyan">
                  <BarChart3 className="h-3 w-3" /> {video.insights}
                </p>
              </div>
              <a
                href={video.link}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="lightbox-link"
                className="inline-flex shrink-0 items-center gap-2 rounded-full bg-brand-gradient px-4 py-2.5 font-display text-[11px] font-bold tracking-[0.12em] text-white transition-transform hover:-translate-y-0.5"
              >
                {video.platform} <ExternalLink className="h-3.5 w-3.5" />
              </a>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
